import React from 'react';
import { motion } from 'framer-motion';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { TrendingUp, Users, DollarSign, MousePointerClick } from 'lucide-react';
const data = [{
  name: 'Ene',
  value: 1000
}, {
  name: 'Feb',
  value: 1500
}, {
  name: 'Mar',
  value: 2200
}, {
  name: 'Abr',
  value: 2800
}, {
  name: 'May',
  value: 3600
}, {
  name: 'Jun',
  value: 4500
}, {
  name: 'Jul',
  value: 5800
}, {
  name: 'Ago',
  value: 7200
}, {
  name: 'Sep',
  value: 8900
}, {
  name: 'Oct',
  value: 10500
}, {
  name: 'Nov',
  value: 12800
}, {
  name: 'Dic',
  value: 15000
}];
const testimonials = [{
  quote: 'La forma en que Luca explica el marketing de afiliados cambió por completo mi perspectiva. Logré mi primera venta en menos de un mes.',
  name: 'Carlos M.',
  role: 'Emprendedor Digital',
  avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?q=80&w=150&auto=format&fit=crop'
}, {
  quote: 'Directo al grano, sin humo. Las estrategias de tráfico orgánico son oro puro para quienes empezamos desde cero.',
  name: 'Laura S.',
  role: 'Creadora de Contenido',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&auto=format&fit=crop'
}, {
  quote: 'Disciplina y enfoque. Esos dos conceptos, aplicados a las tácticas de Luca, me permitieron escalar mis ingresos online.',
  name: 'Andrés V.',
  role: 'Afiliado Profesional',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150&auto=format&fit=crop'
}];
export function SocialProof() {
  return <section className="py-24 md:py-32 relative bg-[#08080a]" data-id="element-124">
      <div className="container mx-auto px-6" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 md:mb-24" data-id="element-126">
          <h2 className="text-3xl md:text-5xl font-bold text-zinc-100 mb-6" data-id="element-127">
            Resultados que hablan
          </h2>
          <p className="text-zinc-400 max-w-2xl mx-auto text-lg" data-id="element-128">
            Construyendo en la nueva economía digital con estrategias basadas en
            datos, constancia y ejecución real.
          </p>
        </motion.div>

        {/* Dashboard Mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-5xl mx-auto bg-[#0a0a0b] border border-white/10 rounded-3xl p-6 md:p-10 shadow-2xl mb-20 relative overflow-hidden" data-id="element-129">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-amber-400/50 to-transparent" data-id="element-130" />

          {/* KPI Tiles */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10" data-id="element-131">
            {[{
            label: 'Crecimiento de Ingresos',
            value: '+145%',
            icon: DollarSign
          }, {
            label: 'Tasa de Conversión',
            value: '4.8%',
            icon: MousePointerClick
          }, {
            label: 'Tráfico Activo',
            value: '120K',
            icon: TrendingUp
          }, {
            label: 'Comunidad',
            value: '15K+',
            icon: Users
          }].map((kpi, i) => <div key={i} className="bg-white/[0.02] border border-white/5 rounded-xl p-4 md:p-6" data-id="element-132">
                <div className="flex items-center gap-3 mb-3" data-id="element-133">
                  <kpi.icon className="w-4 h-4 text-amber-400" data-id="element-134" />
                  <span className="text-xs text-zinc-400 font-medium uppercase tracking-wider" data-id="element-135">
                    {kpi.label}
                  </span>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-zinc-100" data-id="element-136">
                  {kpi.value}
                </div>
              </div>)}
          </div>

          {/* Chart Area */}
          <div className="h-[300px] md:h-[400px] w-full" data-id="element-137">
            <ResponsiveContainer width="100%" height="100%" data-id="element-138">
              <AreaChart data={data} margin={{
              top: 10,
              right: 0,
              left: -20,
              bottom: 0
            }} data-id="element-139">
                <defs data-id="element-140">
                  <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1" data-id="element-141">
                    <stop offset="5%" stopColor="#D4AF37" stopOpacity={0.3} data-id="element-142" />
                    <stop offset="95%" stopColor="#D4AF37" stopOpacity={0} data-id="element-143" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} data-id="element-144" />
                <XAxis dataKey="name" stroke="rgba(255,255,255,0.2)" fontSize={12} tickLine={false} axisLine={false} data-id="element-145" />
                <YAxis stroke="rgba(255,255,255,0.2)" fontSize={12} tickLine={false} axisLine={false} tickFormatter={value => `${value / 1000}k`} data-id="element-146" />
                <Tooltip contentStyle={{
                backgroundColor: '#0a0a0b',
                borderColor: 'rgba(255,255,255,0.1)',
                borderRadius: '8px',
                color: '#fff'
              }} itemStyle={{
                color: '#D4AF37'
              }} data-id="element-147" />
                <Area type="monotone" dataKey="value" stroke="#D4AF37" strokeWidth={2} fillOpacity={1} fill="url(#colorValue)" data-id="element-148" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </motion.div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-149">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white/[0.02] border border-white/5 p-8 rounded-2xl relative" data-id="element-150">
              <div className="text-amber-400 text-4xl font-serif absolute top-6 left-6 opacity-20" data-id="element-151">
                "
              </div>
              <p className="text-zinc-300 text-sm leading-relaxed mb-6 relative z-10" data-id="element-152">
                {testimonial.quote}
              </p>
              <div className="flex items-center gap-4" data-id="element-153">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover border border-white/10" data-id="element-154" />
                <div data-id="element-155">
                  <div className="text-sm font-bold text-zinc-100" data-id="element-156">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-zinc-500" data-id="element-157">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}